import React, { useContext, memo } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import PriceLabel from '@prisjakt/ui-price-label';
import Currency from '@prisjakt/ui-currency';

import * as S from './styles';
import { LatestPriceChange } from '../../../../types';

type AlertPrice = {
  price: {
    regular?: number | null;
  };
  latestPriceChange?:
    | LatestPriceChange
    | (LatestPriceChange & { time: string; amount: number })
    | null;
};

const AlertPrice = ({ price, latestPriceChange }: AlertPrice) => {
  const { t } = useContext(AppContext);
  const rawPriceChange = latestPriceChange && latestPriceChange.amount;
  const rawPrice = price.regular;

  const hasRegularPrice = !!rawPrice;

  const priceUp = rawPriceChange && rawPriceChange > 0;
  const priceDown = rawPriceChange && rawPriceChange < 0;

  const showPriceChange =
    hasRegularPrice && latestPriceChange && (priceUp || priceDown);

  return (
    <S.AlertPrice>
      {latestPriceChange && (
        <S.AlertTimeText key="label">{latestPriceChange.time}</S.AlertTimeText>
      )}

      <div>
        {latestPriceChange && Boolean(showPriceChange) && (
          <S.PriceChange key="price" up={Boolean(priceUp)}>
            <Currency asDiff price={latestPriceChange.amount} />
          </S.PriceChange>
        )}

        {price.regular && hasRegularPrice ? (
          <PriceLabel value={price.regular} />
        ) : (
          <S.LightText>{t('alerts', 'list.no-price-found')}</S.LightText>
        )}
      </div>
    </S.AlertPrice>
  );
};

AlertPrice.defaultProps = {
  latestPriceChange: null,
};

export default memo(AlertPrice);
